import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({ size, ...rest }: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C12.2761 2 12.5 2.22386 12.5 2.5L12.501 4.01791C15.9935 4.26936 18.7501 7.12428 18.8709 10.6346L18.875 10.8749V15.2799L18.9656 15.3106C19.4838 15.5126 19.8693 15.9717 19.9725 16.5262L19.9936 16.6797L20 16.8249V17.4999C20 18.2796 19.4051 18.9204 18.6445 18.9931L18.5 18.9999L15.874 18.9998C15.4301 20.7251 13.8639 22 12 22C10.1361 22 8.56991 20.7251 8.12595 18.9998L5.5 18.9999C4.7203 18.9999 4.07955 18.405 4.00687 17.6444L4 17.4999V16.8249C4 16.167 4.39099 15.6004 4.95328 15.3448L5.08598 15.2915L5.125 15.2789V10.8749C5.125 7.24608 7.93651 4.27389 11.5001 4.01782L11.5 2.5C11.5 2.22386 11.7239 2 12 2ZM14.8293 18.9999H9.17067C9.58249 20.1651 10.6937 21 12 21C13.3063 21 14.4175 20.1651 14.8293 18.9999ZM12.2199 5.00387L12.0072 4.99995L11.9902 4.99985C8.82832 5.00038 6.24485 7.51239 6.12905 10.6547L6.125 10.8749V15.6999C6.125 15.9454 5.94812 16.1495 5.71488 16.1919L5.53264 16.2067C5.26474 16.2464 5.05226 16.4561 5.00834 16.7225L5 16.8249V17.4999C5 17.7454 5.17688 17.9495 5.41012 17.9919L5.5 17.9999H18.5C18.7455 17.9999 18.9496 17.823 18.9919 17.5898L19 17.4999V16.8249C19 16.5407 18.8091 16.2978 18.5646 16.2249L18.4707 16.2058L18.3481 16.1992C18.1123 16.1865 17.9219 16.0118 17.8825 15.7866L17.875 15.6999V10.8749C17.875 7.78418 15.4838 5.23869 12.4434 5.01599L12.2199 5.00387Z"
          fill="#616161"
        />
        <circle cx="17" cy="7" r="3" fill="#F00001" />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 불가능,
 *
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'notification-alert');
export default IconComponent;
